import { useState } from 'react'
import { 
  Box,
  Button, 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle, 
} from '@mui/material'

import { useSignOut } from '../../hooks/auth'
import Loading from '../../views/loading'

export default function AccountLogout({ onSignout }: { onSignout: () => void}) {
  const [open, set] = useState(false)
  const [signOut, loading] = useSignOut()

  if (loading) return <Loading />

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
        }}
      >
        <Button variant="text" color="inherit" onClick={() => set(true)}>Logga ut</Button>
        
      </Box>

      <Dialog
        open={open}
        onClose={() => set(false)}
        fullWidth
        maxWidth="xs"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Logga ut?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Är du säker på att du vill logga ut?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => set(false)}>Avbryt</Button>
          <Button onClick={signOut} autoFocus color="error">
            Logga ut
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
